import { useTranslation } from 'react-i18next';
import ServiceIconGlyph from './ServiceIconGlyph';
import { getPackageServiceLabel, resolvePackageService } from './packageServiceIcons';

function normalizeIcon(included) {
  if (typeof included === 'string') {
    return { codigo: included };
  }
  if (included?.code) {
    return { codigo: included.code, descripcion: included.description };
  }
  return included?.icon || included || null;
}

export default function ServiceTiles({ items }) {
  const { t } = useTranslation('layout');
  if (!items?.length) return null;

  return (
    <div className='detail-services-row'>
      {items.map((included, index) => {
        const icon = normalizeIcon(included);
        if (!resolvePackageService(icon)) return null;
        const label = getPackageServiceLabel(icon, t);
        return (
          <div
            className='service-tile'
            key={typeof included === 'string' ? index : included.id || icon.id || `service-${index}`}
          >
            <ServiceIconGlyph icon={icon} />
            {label ? <span>{label}</span> : null}
          </div>
        );
      })}
    </div>
  );
}
